export const calcHeight = (ratio1: number, ratio2: number, width: number) => {
	const ratio = ratio1 / ratio2;

	return width / ratio;
};
